/**
 * PHARMAKON — « type de produit → champs » of the creation panel S2 and the fiche produit
 * (design/ux/02_achats.md §5.3, OP-ACH-05…09; refonte WP-24).
 *
 * Which fields exist for each type comes from the browser twin of the server CONFIG
 * (`@pharmakon/shared/constants/produit-type-champs.js`, parity-tested against the server's
 * `config/produit-type-champs.config.js` and its validator) — the server applies the same table
 * to every write, so a field hidden here can never be stored by another path (AUD-PRODNEW-02/-03).
 * This file adds only what the screen needs: the defaults of §5.3 (the type choices are the officine's
 * catalogue — refonte WP-68). Labels come from config/app.config.js, never typed twice.
 */
import {
  CHAMP_TYPE,
  CHAMPS_PAR_TYPE,
  CHAMPS_PRODUCTEUR,
  CODES_BARRE_MAX_PAR_PRODUIT,
  CREATION_REQUETE_ID_MAX,
  DESCRIPTION_LONGUEUR_MAX,
  NOM_COMMERCIAL,
  PRODUIT_MONTANT_MAX,
  TVA_DEFAUT_PAR_TYPE,
  TYPES_DERMO,
  TYPES_PRODUIT,
  producteurDuType,
  typePorte,
} from "@pharmakon/shared/constants/produit-type-champs.js";
import { TAUX_TVA_ACHAT } from "@pharmakon/shared/constants/achat-saisie.js";
import { SHP_PAR_CLASSIFICATION } from "./shp.config.js";

export {
  CHAMP_TYPE,
  CHAMPS_PAR_TYPE,
  CHAMPS_PRODUCTEUR,
  CODES_BARRE_MAX_PAR_PRODUIT,
  CREATION_REQUETE_ID_MAX,
  DESCRIPTION_LONGUEUR_MAX,
  NOM_COMMERCIAL,
  PRODUIT_MONTANT_MAX,
  TVA_DEFAUT_PAR_TYPE,
  TYPES_DERMO,
  TYPES_PRODUIT,
  producteurDuType,
  typePorte,
};

// Refonte WP-68 (A-117) — the « Type de produit » choices are the officine's catalogue
// (`lib/types-produit.js` `optionsTypes`, `hooks/useCatalogueTypes.js`), no longer a list of this file.

/** The TVA select of S2 (the legal rates; « Choisir… » first when the type has no default — OP-ACH-08). */
export const TVA_PRODUIT_OPTIONS = Object.freeze(
  TAUX_TVA_ACHAT.map((t) => Object.freeze({ value: String(t), label: `${t} %` })),
);

/** §5.3 Classification: « Liste I / Liste II / Hors liste / Tableau B »; SHP read-only next to it. */
export const CLASSIFICATION_OPTIONS = Object.freeze([
  Object.freeze({ value: "LISTE_I", label: "Liste I" }),
  Object.freeze({ value: "LISTE_II", label: "Liste II" }),
  Object.freeze({ value: "HORS_LISTE", label: "Hors liste" }),
  Object.freeze({ value: "TABLEAU_B", label: "Tableau B" }),
]);

/** §5.3 default classification: Hors liste (today's default, useInlineCreate.jsx:680-682). */
export const CLASSIFICATION_DEFAUT = "HORS_LISTE";

/** The classifications a psychotrope may carry (server cross-field rule, produit.validator). */
export const CLASSIFICATIONS_PSYCHOTROPE = Object.freeze(["LISTE_I", "TABLEAU_B"]);

/** SHP of a classification (config/shp.config.js), shown read-only next to it. */
export const shpDeClassification = (c) => SHP_PAR_CLASSIFICATION[c] ?? 0;

/** The TVA proposed for a type, as the select's string value, or "" (explicit choice, OP-ACH-08). */
export const tvaDefautPourType = (type) => (TVA_DEFAUT_PAR_TYPE[type] != null ? String(TVA_DEFAUT_PAR_TYPE[type]) : "");

/** The dosage column holds the « Contenance » of these types (OP-ACH-05). */
export const libelleDosage = (type) => (typePorte(type, CHAMP_TYPE.DOSAGE) ? "dosage" : typePorte(type, CHAMP_TYPE.CONTENANCE) ? "contenance" : null);
